// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__1qeQI","input":"form_input__2WKVR","actions":"form_actions__tFrso"};